"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const t = require("io-ts");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const _ActionTypes = require("./actionTypes");
const _Actions = require("./actions");
const errorHandling_1 = require("../../utils/errorHandling");
const sok_types_1 = require("@caddigital/sok-types");
function default_1(namespace) {
    const ActionTypes = _ActionTypes.default(namespace);
    const Actions = _Actions.default(namespace);
    function fetchRevisionsList(action$, _store, { ajax, getToken, baseUrl }) {
        return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.FETCH_REQUEST), (0, operators_1.mergeMap)((action) => ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: getToken()
            },
            method: 'GET',
            url: `${baseUrl}api/files/${action.payload.uuid}/revisions?hierarchyType=${action.payload.hierarchyType}`
        }).pipe((0, operators_1.mergeMap)((res) => {
            const validator = t.array(t.union([sok_types_1.File.iRevision, sok_types_1.File.iRevisionSimplified]));
            const validation = validator.decode(res.response);
            const act = validation.fold((e) => Actions.fetchFailed((0, errorHandling_1.parseValidationError)(e)), (e) => {
                if (action.payload.hierarchyType === 'COMPLETE') {
                    return Actions.fetchSuccess(e);
                }
                return Actions.fetchSuccess(e);
            });
            return (0, rxjs_1.of)(act);
        }))));
    }
    function deleteLatestRevision(action$, _store, { ajax, getToken, baseUrl }) {
        return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.DELETE_LATEST_REVISION_REQUEST), (0, operators_1.mergeMap)((action) => ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: getToken()
            },
            method: 'DELETE',
            body: {
                uuid: action.payload
            },
            url: `${baseUrl}api/files/revision`
        }).pipe((0, operators_1.mergeMap)((res) => {
            const validation = sok_types_1.File.iRevision.decode(res.response);
            const act = validation.fold((e) => [
                Actions.deleteLatestRevisionFailed((0, errorHandling_1.parseValidationError)(e))
            ], (rev) => [
                Actions.deleteLatestRevisionSuccess(),
                Actions.fetchRequest(rev.fileUuid)
            ]);
            return (0, rxjs_1.of)(...act);
        }), (0, operators_1.catchError)((e) => (0, rxjs_1.of)(Actions.deleteLatestRevisionFailed((0, errorHandling_1.parseAjaxErrorResponse)(e)))))));
    }
    return { fetchRevisionsList, deleteLatestRevision };
}
exports.default = default_1;
//# sourceMappingURL=epics.js.map